"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelOrder = void 0;
const spl_token_1 = require("@solana/spl-token");
const utils_1 = require("../utils");
const constants_1 = require("../constants");
async function cancelOrder(params) {
    const { wallet, tokenAccount, tokenAccountMint, treasuryMint, authority, authorityBump, auctionHouse, feeAccount, tradeState, candyShop, price, amount, program } = params;
    const [sellTradeState, sellTradeStateBump] = await (0, utils_1.getAuctionHouseTradeState)(auctionHouse, wallet.publicKey, tokenAccount, treasuryMint, tokenAccountMint, amount, price);
    await (0, utils_1.checkNftAvailability)(program.provider.connection, tokenAccount, sellTradeState, sellTradeStateBump, amount.toNumber());
    const txHash = await program.methods
        .cancelWithProxy(price, amount, authorityBump)
        .accounts({
        wallet: wallet.publicKey,
        tokenAccount,
        tokenMint: tokenAccountMint,
        authority,
        auctionHouse,
        auctionHouseFeeAccount: feeAccount,
        tradeState,
        candyShop,
        ahProgram: constants_1.AUCTION_HOUSE_PROGRAM_ID,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID
    })
        .rpc();
    console.log('sell order cancelled');
    return txHash;
}
exports.cancelOrder = cancelOrder;
